import React from 'react';
import { useFormContext } from 'react-hook-form';
import { baseInputClass, inputBox, labelBox } from '../styles.module.css';

import { getErrorMessage } from '../utils';
import FieldWrapper from './FieldWrapper';

const BaseInputBox = ({
  defaultValue,
  id,
  label,
  max,
  min,
  type,
  inputClass,
  labelClass,
  onChange,
}) => {
  const { register } = useFormContext();
  return (
    <>
      <input
        id={id}
        name={id}
        type={type}
        defaultValue={defaultValue}
        min={min}
        max={max}
        className={inputClass}
        onChange={onChange}
        ref={register({
          min,
          max,
        })}
      />
      <div className={labelClass}>{label}</div>
    </>
  );
};

const GroupInput = (props) => {
  const { errors } = useFormContext();
  const { errorMessage, id: groupId, onChange, subFields } = props;
  const errorList = subFields
    .map((subField) =>
      getErrorMessage({
        ...subField,
        errors: errors?.[groupId] || {},
      }),
    )
    .filter((i) => !!i);
  const error =
    errorList.length > 0 || errors?.[groupId] != null ? errorMessage : null;

  return (
    <FieldWrapper error={error} fieldClassName={baseInputClass} {...props}>
      {subFields.map((subProps) => {
        const { id, ...restProps } = subProps;
        const subId = `${groupId}.${id}`;
        return (
          <div className={baseInputClass} key={subId}>
            <BaseInputBox
              key={subId}
              id={subId}
              inputClass={inputBox}
              labelClass={labelBox}
              onChange={onChange}
              {...restProps}
            />
          </div>
        );
      })}
    </FieldWrapper>
  );
};

export default GroupInput;
